import React from 'react';

import * as styles from './NumericalLozenge.styles';

export interface NumericalLozengeProps {
  /** For a light surface: the number is reversed out of a filled lozenge. */
  inverted?: boolean;
  value: `${number}` | `${number}+`;
}

export const NumericalLozenge = ({ inverted = false, value }: NumericalLozengeProps) => {
  return (
    <span css={styles.numericalLozenge} data-inverted={inverted}>
      {value}
    </span>
  );
};
